export const GET_ALL_FRAME_TYPES_REQUEST = "GET_ALL_FRAME_TYPES_REQUEST";
export const GET_ALL_FRAME_TYPES_SUCCESS = "GET_ALL_FRAME_TYPES_SUCCESS";
export const GET_ALL_FRAME_TYPES_FAILURE = "GET_ALL_FRAME_TYPES_FAILURE";
export const ADD_FRAME_TYPE_SUCCESS = "ADD_FRAME_TYPE_SUCCESS";
export const DELETE_FRAME_TYPE_SUCCESS = "DELETE_FRAME_TYPE_SUCCESS";
export const UPDATE_FRAME_TYPE_SUCCESS = "UPDATE_FRAME_TYPE_SUCCESS";
